<script setup lang="tsx">
import type { Column } from '@/stores/column'
import { computed, type Ref } from 'vue'
import type { CustomValueMap } from '@/services/custom'
import CustomValueDisplay from './CustomValueDisplay.vue'
import CustomValueEdit from './CustomValueEdit.vue'

const model = defineModel<CustomValueMap>()

const props = defineProps<{
	isEdit?: boolean
	columns: Ref<Column>[]
	rowId: number
	table?: string
}>()

function set(definitionId: number) {
	if (!model.value) model.value = {}
	if (!model.value[definitionId]) model.value[definitionId] = {}
}

const visibleColumns = computed(() => {
	return props.columns.filter((ch) => ch.value.isVisible && (!props.table || ch.value.customField?.table === props.table))
})
</script>

<template>
	<template v-if="model">
		<td v-for="ch in visibleColumns" :key="ch.value.customField?.id + '_' + props.rowId">
			<template v-if="ch.value.customField">
				{{ set(ch.value.customField.id) }}
				<CustomValueDisplay
					v-if="!props.isEdit"
					:field="ch.value.customField"
					:value="model[ch.value.customField.id][props.rowId]"
				></CustomValueDisplay>
				<CustomValueEdit v-else :field="ch.value.customField" v-model="model[ch.value.customField.id][props.rowId]"></CustomValueEdit>
			</template>
		</td>
	</template>
</template>

<style lang="sass" scoped></style>
